import { TextStyleTransformer } from '../text-style-transformer.js';
import RicosTextualTheme from '../textual-theme/textual-theme.js';
import { RicosTextStyle } from './text-style.js';
import { RicosNodeStyle } from './node-style.js';
import { TextNodeTransformer } from '../text-node-transformer.js';
import RicosTextNodeStyle from './text-node-style.js';
import { Decorations } from '../decorations/decorations.js';
import '../utils-398956f3.js';
import 'ricos-content/libs/utils';
import '../textual-theme/custom-styles.js';
import '../textual-theme/empty-custom-style.js';
import '../textual-theme/custom-style.js';
import '../themeStrategy/generators/palette.js';
import '../themeUtils-70529429.js';
import '../themeStrategy/generators/identifiers.js';
import '../themeStrategy/palettes/presets.js';
import '../themeStrategy/palettes/wixPaletteUtils.js';
import 'lodash';
import '../themeStrategy/themeStrategy.js';
import 'react';
import '../themeStrategy/generators/typography.js';
import '../themeStrategy/generators/customStyles.js';
import '../themeStrategy/defaults.js';
import 'ricos-schema';
import '../decorations/bold-decoration.js';
import '../decorations/empty-decoration.js';
import '../decorations/color-decoration.js';
import '../decorations/font-size-decoration.js';
import '../decorations/italic-decoration.js';
import '../decorations/underline-decoration.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class RicosDocumentStyle {
  constructor(documentStyle) {
    this.documentStyle = documentStyle;
  }
  static fromNode(node) {
    return new RicosDocumentStyle(new TextNodeTransformer(node).toDocumentStyle());
  }
  getDecoration(nodeType, decorationType) {
    var _a;
    return Decorations.of(((_a = this.documentStyle[nodeType]) == null ? void 0 : _a.decorations) || []).byType(decorationType);
  }
  getDecorations(node) {
    var _a;
    const documentStyleKey = new TextNodeTransformer(node).getDocumentStyleKey();
    return Decorations.of(
      ((_a = this.documentStyle[documentStyleKey]) == null ? void 0 : _a.decorations) || []
    ).toDecorationArray();
  }
  getTextStyle(nodeType) {
    var _a;
    return RicosTextStyle.of({ lineHeight: (_a = this.documentStyle[nodeType]) == null ? void 0 : _a.lineHeight });
  }
  getNodeStyle(nodeType) {
    var _a;
    return RicosNodeStyle.of((_a = this.documentStyle[nodeType]) == null ? void 0 : _a.nodeStyle);
  }
  toStyleTag() {
    const theme = TextStyleTransformer.fromDocumentStyle(this.documentStyle).toTheme();
    return new RicosTextualTheme(theme).toStyleTag();
  }
  toContent() {
    return this.documentStyle;
  }
  setStyle(nodeType, textNodeStyle) {
    const style = new RicosTextNodeStyle(this.documentStyle[nodeType] || { decorations: [] }).overrideWith(textNodeStyle).getTextNodeStyle();
    return new RicosDocumentStyle(__spreadProps(__spreadValues({}, this.documentStyle), { [nodeType]: style }));
  }
  resetStyle(nodeType) {
    return new RicosDocumentStyle(__spreadProps(__spreadValues({}, this.documentStyle), { [nodeType]: {} }));
  }
  mergeWith(documentStyle) {
    return Object.entries(documentStyle).reduce(
      (acc, [key, style]) => acc.setStyle(key, style),
      new RicosDocumentStyle(this.documentStyle)
    );
  }
}

export { RicosDocumentStyle as default };
//# sourceMappingURL=document-style.js.map
